import ScrollButton from "./ScrollButton";

export default ScrollButton;
